import React from 'react';
import ReactPlayer from 'react-player';

import * as VideoWatchPolicy from '../../../utils/video-watch-policy';
import { PROGRESS_STEP } from '../../../utils/progress-tracker';
import ProgressTracker from '../../../utils/progress-tracker';
import Modal from '../../modal/modal';

export default class ZoomedVideoModal extends React.Component {

    constructor(props) {
        super(props);

        this._playedSeconds = props.videoData ? props.videoData.secondsSpent : 0;
        this._lastPosition = props.videoData ? props.videoData.lastPosition : 0;
        this._tracker = new ProgressTracker();
        this._player = null;
        this.onProgress = this.onProgress.bind(this);
        this.onDuration = this.onDuration.bind(this);
    }

    componentDidMount() {
        if (this._lastPosition && this._player) {
            this._player.seekTo(this._lastPosition);
        }
    }

    onProgress(data) {
        const { videoData = { segments: {} } } = this.props;
        this._tracker.push(data.playedSeconds);
        this._lastPosition = Math.floor(data.playedSeconds);
        this._playedSeconds += PROGRESS_STEP;

        this.props.updateVideoData(this.props.videoUrl, {
            secondsSpent: this._playedSeconds,
            lastPosition: this._lastPosition,
            segments: VideoWatchPolicy.sawnSegments(videoData.segments, this._tracker.chunks()),
        });
    }

    onDuration(duration) {
        if (!this.props.videoData) {
            this.props.initVideoData(this.props.videoUrl, {
                secondsSpent: 0,
                lastPosition: 0,
                duration,
                ...VideoWatchPolicy.segments(duration),
            });
        }
    }

    render() {
        const { videoUrl, onClose } = this.props;
        const props = { videoUrl, onClose, contentStyle, onDuration: this.onDuration, onProgress: this.onProgress };

        return <InternalVideoModal {...props} playerRef={ref => this._player = ref} />;
    }
}

class InternalVideoModal extends React.PureComponent {
    render() {
        const { videoUrl, onProgress, onDuration, playerRef, ...rest } = this.props;

        return (
            <Modal show {...rest}>
                <div className='modal-content-wrapper'>
                    <button className='modal-exit-btn' onClick={rest.onClose}>x</button>
                    <div className='zoomed-video'>
                        <ReactPlayer
                            ref={playerRef}
                            url={videoUrl} playing controls
                            onDuration={onDuration}
                            progressInterval={PROGRESS_STEP * 1000} onProgress={onProgress}
                            width='100%' height='100%'
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

const contentStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};



// WEBPACK FOOTER //
// ./src/components/section/components/video-modal.js